import React from "react";
import HomeIcon from "@mui/icons-material/Home";
import RenderSvg from "../../../../../../../../renderSvg/RenderSvg";
import { getDataFromConfig } from "../../../../../../../../../features/salescodeStudio/mandatoryConfigs/manageKPIReview/manageKpiReviewServices";
import "./tagPreview.css";
interface TagPreviewProps {
  kpi: any;
  defaultConfigGlobal : Record<string,any>;
}
// Function to convert Hex to RGBA
const hexToRgba = (hex: string, alpha = 0.5) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const TagPreview: React.FC<TagPreviewProps> = ({ kpi ,defaultConfigGlobal }) => {
  const tagLabel = kpi.title;
  const actionTabColor = getDataFromConfig("KPI_actionTabColor", kpi.id,defaultConfigGlobal );
  const tabSvgPath = getDataFromConfig("KPI_tabSvgPath", kpi.id,defaultConfigGlobal );
  const svgName = tabSvgPath?.match(/\/([^/]+)\.\w+$/)?.[1] || "";

  const renderIcon = (customColor:string) =>
    svgName !== "home" ? (
      <RenderSvg name={svgName} customStyles={{fill:customColor}} />
    ) : (
      <HomeIcon sx={{ color: actionTabColor }} />
    );

  return (
    <div className="tags-container">
      {/* Inactive Tag */}
      <div className="tag-container">
        <div className="tag inactive">
          <div
            className="icon-wrapper"
            style={{ border: `3px solid ${actionTabColor}` , background:hexToRgba(actionTabColor,0.25)  }}
          >
            {renderIcon(actionTabColor)}
          </div>
          <span className="tag-label" style={{color:actionTabColor}}>
            {tagLabel}
          </span>
        </div>
        <div className="tag-name">Default State</div>
      </div>

      {/* Active Tag */}
      <div className="tag-container">
        <div className="tag active" style={{background:actionTabColor }}>
          <div
            className="icon-wrapper"
            style={{ background:"white" }}
          >
            {renderIcon(actionTabColor)}
          </div>
          <span
            className="tag-label"
            style={{ color: "white" }}
          >
            {tagLabel}
          </span>
        </div>
        <div className="tag-name">Selected State</div>
      </div>
    </div>
  );
};

export default TagPreview;
